/* eslint-disable */
export default {
  confirmation: '确认',
  confirmMergeToConference: '是否添加至电话会议？',
  mergeToConference: '合并',
  conferenceCall: '电话会议',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
